(function($) {
    $(function() {

        $('.js-profil-select').change(function(e){
            e.preventDefault();
            if($(this).val() == 3) {
                document.getElementById('logout-form-navbar').submit();
            }
        });

    });
})(jQuery);
